import { IDentalChart } from '@dataTypes/chartingFeature.types'
import {
  isPersistedDentalChart,
  resolveActiveDentalChart,
} from '@utils/active-dental-chart.utils'
import { getFullName } from '@utils/fullname.util'

export interface ChartingInformationSnapshot {
  isPersistedChart: boolean
  isNewChart: boolean
  draftTitle: string
  draftProviderId: string
  persistedTitle: string
  persistedProviderId: string
  persistedProvider: IDentalChart['provider']
  patientName: string
  hasPatientContext: boolean
}

export interface ChartingInformationState {
  charting: {
    createDentalChart: IDentalChart
    selectedDentalChart: IDentalChart | null
    dentalCharts?: IDentalChart[]
    preferCreateDentalChart?: boolean
  }
  patient: {
    selectedPatient:
      | {
          patient_id?: string
          first_name: string
          middle_name?: string
          last_name: string
        }
      | null
      | undefined
  }
}

export const selectChartingInformationSnapshot = (
  state: ChartingInformationState,
  showExistingConditions: boolean,
): ChartingInformationSnapshot => {
  const createDentalChart = state.charting.createDentalChart
  const selectedDentalChart = state.charting.selectedDentalChart
  const activeChart = resolveActiveDentalChart({
    selectedDentalChart,
    createDentalChart,
    dentalCharts: state.charting.dentalCharts ?? [],
    showExistingConditions,
    patientId: state.patient.selectedPatient?.patient_id,
    preferCreateDentalChart: state.charting.preferCreateDentalChart,
  })
  return {
    isPersistedChart: isPersistedDentalChart(activeChart, createDentalChart),
    isNewChart: !createDentalChart.chart_id?.trim(),
    draftTitle: createDentalChart.title ?? '',
    draftProviderId: createDentalChart.provider_id ?? '',
    persistedTitle: activeChart.title ?? '',
    persistedProviderId: activeChart.provider_id ?? '',
    persistedProvider: activeChart.provider,
    patientName:
      getFullName(
        selectedDentalChart?.patient ?? state.patient.selectedPatient,
      ) || 'No Selected Patient',
    hasPatientContext: Boolean(
      selectedDentalChart || state.patient.selectedPatient,
    ),
  }
}
